import React from "react";
import { Outlet } from "react-router";
// MUI Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import Appbar from "../Appbar";
// Custom Components
import NoEnterprises from "../../views/enterpriseDashboard/NoEnterprises";
// Redux
// Redux: selectors
import { selectCurrentEnterprise } from "../../features/enterprise/enterpriseSlice";
// Redux: reducers
// Redux: queries
import { useGetEnterprisesQuery } from "../../features/enterprise/enterpriseApiSlice";

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingY: 1,
    marginY: 2,
  },
};

const drawerWidthLeft = 240;

function EnterpriseDashboardLayout() {
  const { t: tGeneral } = useTranslation("general");

  // Enterprises query from RTK Query
  const {
    data: enterprises,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetEnterprisesQuery();

  const currentEnterprise = useSelector(selectCurrentEnterprise);

  // Define content for the dashboard depending on enterprise query
  let content;
  if (isLoading) {
    content = <Typography>{tGeneral("loadingEnterprises")}</Typography>;
  } else if (isSuccess) {
    /* FIXME: Setting current & main enterprise won't work
      right now if there's more than 1 enterprise */
    if (enterprises.length > 0) {
      content = <Outlet />;
    } else {
      // If user has no enterprises
      content = (
        <Grid item xs={12}>
          <NoEnterprises />
        </Grid>
      );
    }
  } else if (isError) {
    content = <Typography>{JSON.stringify(error)}</Typography>;
  }

  return (
    <>
      <Appbar
        title={currentEnterprise?.name}
        type="enterprise"
        drawerWidthLeft={drawerWidthLeft}
      />
      <Box
        sx={{
          flex: 1,
          width: { sm: `calc(100% - ${drawerWidthLeft}px)` },
          ml: { sm: `${drawerWidthLeft}px` },
          height: "100vh",
        }}
      >
        {/* <div>
          <h3>Manage your things here</h3>
          <Can I="view" a="enterpriseInfo">
            <p>I can view enterprise info (enterprise admin)</p>
          </Can>
        </div> */}
        {content}
      </Box>
    </>
  );
}

export default EnterpriseDashboardLayout;
